/* eslint-disable import/prefer-default-export */
import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Context } from '../../Context/AuthContext';
import getUserDepartments from '../../utils/local-storage';
import { canAccessContratosAssinadosArea } from '../../utils/acl/admin-area';
import { hasPermissao } from '../../utils/acl/permissoes';
import { CONFIGURACOES_KEYS } from '../../utils/acl/configuracoes';
import './styles.css';

// Barra de navegação fixa embaixo, só <768px — mesmos destinos da Sidebar (ver
// src/components/Sidebar/index.js), só que em ícones num carrossel horizontal em vez
// de lista vertical. Qualquer mudança de rota/permissão lá precisa ser refletida aqui.
// Perfil e Suporte (WhatsApp) não estão aqui de propósito - já vivem na Navbar
// (src/components/Navbar/index.js), não duplicar de volta pra cá.
export function BottomNav() {
  const { pathname } = useLocation();
  const { authenticated, handleLogout } = useContext(Context);

  // "authenticated" só reflete se existe token no localStorage (ver AuthContext.js), não se
  // a sessão é válida - e /login continua acessível mesmo com token guardado de sessão
  // anterior. Sem esse segundo check, a barra aparecia atrás do formulário de login.
  if (!authenticated || pathname === '/' || pathname === '/login') return null;

  const userAccess = {
    perfilId: localStorage.getItem('perfilId'),
    isSuperAdmin: localStorage.getItem('permissoesAdmin') === 'true',
    departments: getUserDepartments(),
  };
  const canAccessContratos = canAccessContratosAssinadosArea(userAccess);
  const canAccessConfigMenu = hasPermissao('menu.usuarios')
    || CONFIGURACOES_KEYS.some((chave) => hasPermissao(chave));

  const itens = [
    { to: '/meu-dia', icone: 'fas fa-sun', rotulo: 'Meu dia' },
    hasPermissao('menu.dashboard') && { to: '/dashboard', icone: 'fas fa-chart-line', rotulo: 'Dashboard' },
    hasPermissao('menu.pessoas') && { to: '/pessoas', icone: 'fas fa-users', rotulo: 'Cadastro' },
    hasPermissao('menu.atendimentos') && { to: '/atendimentos-presenciais', icone: 'fas fa-calendar-check', rotulo: 'Agenda' },
    hasPermissao('relatorio.fechamentoDiario') && {
      to: '/admin/relatorios/contratos-assinados', icone: 'fas fa-file-contract', rotulo: 'Fechamento',
    },
    hasPermissao('relatorio.contratosSemAtendimento') && {
      to: '/admin/relatorios/contratos-sem-atendimento', icone: 'fas fa-exclamation-triangle', rotulo: 'Correções',
    },
    hasPermissao('menu.contratosAssinados') && {
      to: '/relatorio-estrategico', icone: 'fas fa-file-signature', rotulo: 'Contratos',
    },
    canAccessContratos && {
      to: '/admin/permissoes', icone: 'fas fa-user-shield', rotulo: 'Permissões',
    },
    canAccessContratos && {
      to: '/admin/usuarios-online', icone: 'fas fa-circle text-success', rotulo: 'Online',
    },
    canAccessConfigMenu && {
      icone: 'fas fa-cog',
      rotulo: 'Config',
      onClick: () => window.dispatchEvent(new CustomEvent('toggle-sidebar-mobile')),
    },
    {
      to: '/', icone: 'fas fa-sign-out-alt', rotulo: 'Sair', onClick: handleLogout,
    },
  ].filter(Boolean);

  const isActive = (to) => to && (pathname === to || pathname.startsWith(`${to}/`));

  return (
    <nav className="bottom-nav-mobile" aria-label="Navegação principal">
      {itens.map((item) => {
        const className = `bottom-nav-item${isActive(item.to) ? ' active' : ''}`;
        const conteudo = (
          <>
            <i className={`fa-fw ${item.icone}`} />
            <span>{item.rotulo}</span>
          </>
        );

        if (!item.to) {
          return (
            <button key={item.rotulo} type="button" onClick={item.onClick} className={className}>
              {conteudo}
            </button>
          );
        }

        return (
          <Link key={item.rotulo} to={item.to} onClick={item.onClick} className={className}>
            {conteudo}
          </Link>
        );
      })}
    </nav>
  );
}
